const isDev = process.env.NODE_ENV === 'development'

export const BE_URL = isDev ? 'http://localhost:3000/api' : 'https://healthyqr.it/api'
export const VIEWER_URL = isDev ? 'http://localhost:5004' : window.location.origin